module.exports = __webpack_public_path__ + "media/images/result_sets/circles/1r2r7n4n-f6dada4aa5da5e2200cc34fe9c8cf90d.svg";